export default __webpack_public_path__ + "static/media/icon2.06081025.svg";